import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRotate360Right: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconRotate360Right"><Path d="M10.5 13.5L13.25 16.25L10.5 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M13 16.25H12C6.33908 16.25 1.75 13.8995 1.75 11C1.75 8.10051 6.33908 5.75 12 5.75C17.6609 5.75 22.25 8.10051 22.25 11C22.25 12.8075 20.4667 14.4016 17.7521 15.346" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconRotate360Right;
